export default "__VITE_ASSET__93540067__"